import { render, staticRenderFns } from "./insureDetail.vue?vue&type=template&id=d74d359c&scoped=true"
import script from "./insureDetail.vue?vue&type=script&lang=js"
export * from "./insureDetail.vue?vue&type=script&lang=js"
import style0 from "./insureDetail.vue?vue&type=style&index=0&id=d74d359c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74d359c",
  null
  
)

export default component.exports